import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { getHasElementsInArray } from 'utils';
import { ShareableLinkAnalyticsMember } from 'models/ShareableLink';
import SecureLinkMember from './components/SecureLinkMember';
import SkeletonRows from '../SkeletonRows';
import { Loader } from 'ncoded-component-library';

import './SecureLinkMembers.styles.scss';

type SecureLinkMembersProps = {
  className?: string;
  isLoading?: boolean;
  shareableLinkId: string;
  members: ShareableLinkAnalyticsMember[];
};

const SecureLinkMembers: React.FC<SecureLinkMembersProps> = (props) => {
  const { className, isLoading, shareableLinkId, members = [] } = props;

  const classes = classNames('secure-link-members', className);

  const { t } = useTranslation();

  const hasMembers = getHasElementsInArray(members);

  const isInitialLoading = isLoading && !hasMembers;

  return (
    <div className={classes}>
      <p>{t('activityByUser')}</p>

      {isInitialLoading ? (
        <SkeletonRows />
      ) : (
        <>
          {isLoading && <Loader />}
          {members.map((member) => (
            <SecureLinkMember
              key={member._id}
              member={member}
              shareableLinkId={shareableLinkId}
            />
          ))}
        </>
      )}
    </div>
  );
};

export default SecureLinkMembers;
